/* ==========================================================================
   OPEN THE CART DRAWER AFTER ADD TO CART.  2026-08-23

   WHY. Measured across Aug 17-22: of the sessions that added something to the
   cart, only 26% ever reached checkout - and just 13% of paid-social sessions,
   which is the traffic the ads pay for. Healthy is 45-50%. The add-to-cart
   toast was the only thing carrying that step and it was not carrying it.
   Opening the drawer puts the CHECKOUT button on screen at the moment of
   intent, instead of asking the shopper to notice the cart badge and go
   looking for it.

   WHY HERE AND NOT IN snippets/cart-drawer.liquid. That file is 49KB and holds
   the add-to-cart JS; its own header says not to put the revenue path at risk
   for a change that does not need to live there. This file is purely additive -
   nothing in the drawer snippet is touched, and the entire change reverts by
   deleting the one script tag in snippets/slc-head.liquid.

   HOW. cart-drawer.liquid patches cart-drawer.open() to ignore calls with no
   argument (slcPatchAutoOpen). That patch is deliberately LEFT IN PLACE so
   there is still a single gatekeeper and nothing in Dawn or an app can open
   the drawer unpredictably. Passing a truthy triggeredBy satisfies the patch -
   the same door the toast's own "View cart" button already uses - and gives
   Dawn an element to return focus to on close.

   THE TOAST CANNOT DOUBLE UP. slcShowToast() returns early while the drawer is
   active, and cart-drawer.liquid runs a MutationObserver that hides the toast
   as soon as the drawer gains .active.

   TIMING. cart-drawer.liquid waits 350ms after a successful /cart/add, then
   fetches fresh section HTML. Opening at 700ms lands just after that. If it
   ever lands early the drawer simply re-renders in place, which is what Dawn
   does anyway.
   ========================================================================== */
(function () {
  if (window.__slcCartReveal) return;
  window.__slcCartReveal = true;

  var OPEN_DELAY = 700;

  function slcRevealCart() {
    var cd = document.querySelector('cart-drawer');
    /* No drawer on this page - leave the toast to do its job. */
    if (!cd || typeof cd.open !== 'function') return;
    /* Already open: the in-drawer variant switcher re-adds a line while the
       shopper is looking at it. Re-running open() would steal focus. */
    if (cd.classList.contains('active')) return;
    try {
      cd.open(document.activeElement || document.body);
    } catch (e) {}
  }

  var origFetch = window.fetch;
  if (typeof origFetch !== 'function') return;

  window.fetch = function (input, init) {
    var p = origFetch.apply(this, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (typeof url === 'string' && /\/cart\/add/.test(url)) {
      p.then(function (res) {
        if (res && res.ok === false) return;
        setTimeout(slcRevealCart, OPEN_DELAY);
      }).catch(function () {});
    }
    return p;
  };
})();
